import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "components/Headers/Header";
import AdjuntosCargados from "./AdjuntosCargados";
import CreaComentarios from "views/Crea/CreaComentarios";

const AdjuntosOrden = () => {
  const { id, ordenId } = useParams();
  const [documento, setDocumento] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [activarCamara, setActivarCamara] = useState(false);
  const [list, setList] = useState([]);
  const [cargando, setCargando] = useState(false); // Estado de carga

  useEffect(() => {
    axios
      .get(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerListaDocumentos/${id}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  }, [id]);

  const manejarCambioDocumento = (event) => {
    const seleccionado = event.target.value;
    setDocumento(seleccionado);
    setActivarCamara(["17", "18", "19", "20"].includes(seleccionado));
    setArchivo(null);
  };

  const manejarCambioArchivo = (event) => {
    setArchivo(event.target.files[0]);
  };

  const subirArchivo = async () => {
    if (!archivo) {
      console.error("No se ha seleccionado ningún archivo.");
      return;
    }

    setCargando(true); // Inicia el loading

    const formData = new FormData();
    formData.append("file", archivo);

    try {
      const response = await axios.post(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaAnexoOrden?OrdenId=${ordenId}&AnexoId=${documento}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      console.log("Respuesta del servidor:", response.data);
      alert(response.data);
      window.location.reload("/");
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      alert("Error al subir el archivo");
    } finally {
      setCargando(false); // Termina el loading
    }
  };

  const botonGuardar = (
    <Button color="primary" block onClick={subirArchivo} disabled={cargando}>
      {cargando ? (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>{" "}
          Cargando...
        </>
      ) : (
        "Guardar"
      )}
    </Button>
  );

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <hr />
              </CardHeader>
              <CardBody>
                <center>
                  <select
                    className="btn btn-secondary btn-user btn-block"
                    id="solicitudid"
                    onChange={manejarCambioDocumento}
                  >
                    <option value="">Seleccione el documento a cargar</option>
                    {list.map(({ id, adjunto }) => (
                      <option key={id} value={id}>
                        {adjunto}
                      </option>
                    ))}
                  </select>
                </center>
                <hr />
                {activarCamara ? (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      className="btn btn-secondary btn-user btn-block"
                      onChange={manejarCambioArchivo}
                    />
                    <br />
                    <hr />
                    {botonGuardar}
                  </>
                ) : (
                  <>
                    <input
                      type="file"
                      name="files"
                      className="btn btn-secondary"
                      onChange={manejarCambioArchivo}
                    />
                    <br />
                    <hr />
                    {id === "0" && (
                      <div>
                        Si tiene comentarios haga click en el botón inferior:
                        <br />
                        <br />
                        <CreaComentarios ordenId={ordenId} />
                      </div>
                    )}
                    <br />
                    <hr />
                    {botonGuardar}
                  </>
                )}
                <hr />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <AdjuntosCargados OrdenId={ordenId} />
      </Container>
      <hr />
    </>
  );
};

export default AdjuntosOrden;
